import { Link } from 'react-router-dom';
import ResourceCard from '../components/ResourceCard';
import resources from '../data/resources';
import './Resources.css';

function Resources() {
  const sorted = [...resources].sort((a, b) => b.date.localeCompare(a.date));

  return (
    <div className="page">
      <a className="skip-link" href="#resources">
        Skip to resources
      </a>

      <header className="page-header">
        <Link to="/" className="back-link spec">
          Brian Gerhards
        </Link>

        <div className="page-titles">
          <h1 className="page-title">AI Resources</h1>
          <span className="page-count spec">
            {sorted.length} {sorted.length === 1 ? 'entry' : 'entries'}
          </span>
        </div>

        <p className="page-intro">
          Prompts, skills, and custom agents I actually use. Newest first.
        </p>
      </header>

      <main id="resources">
        {sorted.length === 0 ? (
          <p className="empty">Nothing published yet.</p>
        ) : (
          <ul className="entries">
            {sorted.map((resource) => (
              <li key={resource.id}>
                <ResourceCard resource={resource} />
              </li>
            ))}
          </ul>
        )}
      </main>
    </div>
  );
}

export default Resources;
